module.exports = __webpack_public_path__ + "static/logo-umbria-eaee4539dfab02bd046f9262c0fa86ea.jpg";